import { get, postAPI, putAPI, deleteAPI } from "../services/api.services";
import Swal from "sweetalert2";
const { defaultPage } = require('../Common/Constant');

export const attributeSetList = async({page=defaultPage.current_page, recPerPage=defaultPage.perPage, searchKeyword = ""}) => {
    let data = {
        page: page,
        recPerPage: recPerPage,
        q: searchKeyword
    }
    let res = await postAPI('/attribute-set/list', data)
    return res;
}

export const attributeSetDetails = async({payload}) => {
    let res = await get('/attribute-set/details/'+payload);
    return res;
}

export const attributeSetDelete = async({id}) => {
    return Swal.fire({
        text: 'Are you sure you want to delete?',
        confirmButtonText: 'Yes',
        showCancelButton: true,
    }).then(async (result) => {
        if (result.value) {
            let res = await deleteAPI('/attribute-set/delete/'+id)
            return Swal.fire({
                text:res.message,
                timer: 1500,
            }).then(() => {
                return res;
            })
        }
    })
}

export const attributeSetUpdateStatus = async({id, status}) => {
    return Swal.fire({
        text: 'Are you sure you want to update?',
        confirmButtonText: 'Yes',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
            let res = await putAPI('/attribute-set/update-status/'+id+'/'+status)
            return Swal.fire({
                text:res.message,
                timer: 1500,
            }).then(() => {
                return res;
            })
        }
      })
}

export const attributeSetCreate = async({payload}) => {
    let res = await postAPI('/attribute-set/add', payload)
    return Swal.fire({
        text:res.message,
        timer: 1500,
    }).then(() => {
        return res;
    })
}

export const attributeSetUpdate = async({payload}) => {
    let data = {
        parentID: payload.parentID,
        name: payload.name,
        imageURL: payload.imageURL,
        priority: payload.priority,
        status: payload.status
    }
    let res = await putAPI('/attribute-set/update/'+payload?.id, data)
    return res;
}

export const attributeSetCheckName = async({name, id = 0}) => {
    let data = {
        name: name,
        id: id
    }
    let res = await postAPI('/attribute-set/check-unique', data);
    return res;
}